module.exports = __webpack_public_path__ + "static/media/ForestQuiz.1371c32b.jpg";